// src/plugins/axios.js
import axios from 'axios';
import router from '@/router/index';
// import store from '@/store/index.js';
import { Message } from 'element-ui'; // 引入 Element UI 的 Message 组件

// 从cookie中获取值的函数
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return '';
}

let services = axios.create({
    // 方式1: 环境变量配置（推荐）
    // baseURL: process.env.VUE_APP_API_BASE_URL,
    
    // 方式2: 直接配置（备用）
    // baseURL: 'https://1688.lanjingyuncang.cn/prod-api',
    
    // 方式3: 根据环境判断（当前启用）
    baseURL: process.env.NODE_ENV === 'development'
        ? 'http://192.168.101.72:8080'
        : 'https://1688.lanjingyuncang.cn/prod-api',
});
// 添加401错误提示标识，初始为false（未提示）
let is401Prompted = false;

let is200Prompted = false;
// 请求拦截器
services.interceptors.request.use(
    config => {
        config.headers = config.headers || {};
        // 在发送请求之前做些什么
        // 例如，添加请求头
        let token = localStorage.getItem("access_token")  //每次退出的时候回清掉   
        // let ShopNumbers = JSON.parse(localStorage.getItem("storeList"))   //退出时没必要清掉，因为依然会跳转到我们的登录页。toke失效
        if (token) {
            config.headers['Authorization'] = 'Bearer' + " " + token;
            config.headers['clientId'] = "1d82681b010beca374099f4dfb7cd526";
        }

        // 解密接口/解密网关可能需要 cookie
        // 注意：浏览器禁止手动设置请求头里的 Cookie（会抛 Refused to set unsafe header）
        // 因此只能依赖 withCredentials 由浏览器自动携带 cookie。

        // _ati 既有可能由 cookie 提供，也由拦截器统一透传
        const atiValue = getCookie('_ati');
        if (atiValue) {
            // 对可能包含非 ASCII 字符的 cookie 值进行编码
            config.headers['_ati'] = encodeURIComponent(atiValue);
        }

        // 只对解密相关接口强制透传 Cookie，避免影响其它业务请求
        const url = (config.url || "").toString();
        const needCookieForDecrypt =
            url.includes("getDecryptionParameters");

        // 关键：开启 withCredentials，让浏览器自动带上其持有的 Cookie
        // （避免 HttpOnly cookie 前端拿不到 document.cookie，导致注入失败）
        if (needCookieForDecrypt) {
            config.withCredentials = true;
        }

        // 不要手动注入 Cookie header；让浏览器在 withCredentials=true 时自动携带。
            
            // 从本地存储读取已选择的店铺ID
            let selectedShopIds = JSON.parse(localStorage.getItem("selectedShopIds") || "[]");
            if (selectedShopIds && selectedShopIds.length > 0) {
                // 过滤掉空值，并用逗号连接成字符串 (首次进入有逗号产生) 
                config.headers['Shop-Numbers'] = selectedShopIds.filter(id => id && String(id).trim()).join(',');
            }
        return config;
    },
    error => {
        // 对请求错误做些什么

        return Promise.reject(error);
    }
);

// 响应拦截器
services.interceptors.response.use(
    response => {
        // 对响应数据做点什么
        let res = response;
        
        // 检查是否有 code 字段
        if (res.data.code !== undefined) {
            // 成功状态码（根据实际API定义调整）
            if (res.data.code === 200) {
                return res;
            }

            // 假设服务器返回的响应中，code 为 200 表示请求成功
            if (res.data.code == 401) {
                // 只有当未提示过时才进行提示和跳转
                if (!is401Prompted) {
                    console.error('请求失败:', res.data.message || '未知错误');
                    Message.warning('登录已过期，请重新登录');
                    // 清除本地存储的 token
                    localStorage.removeItem("access_token");
                    localStorage.removeItem("scope");
                    localStorage.removeItem("selectedShopIds");
                    router.push("/login");
                    // 将标识设为已提示
                    is401Prompted = true;
                    // 跳转后重置标识，避免后续登录后再次请求时受影响（可选，根据业务场景调整）
                    setTimeout(() => {
                        is401Prompted = false;
                    }, 1000);
                }
            }

            if (res.data.code !== 200 && res.data.code !== 401) {
                if (!is200Prompted) {
                    Message.warning(res.data.msg)
                    is200Prompted = true
                    setTimeout(() => {
                        is401Prompted = false;
                        is200Prompted = false
                    }, 1000);
                }
            }
        }

        return res;
    },
    error => {
        // 对响应错误做点什么
        console.error('响应错误:', error.message);
        return Promise.reject(error);
    }
);



export default services;